// Action keys and prefixes for executeAction calls
export const ORDER_ACTION_PREFIX = 'order/';
export const ORDER_DECISION_ON_CLAIM_ACTION = 'order/decision-on-claim';
